module.exports = __webpack_public_path__ + "media/images/footer-logo-a58e40ebbce3f00a3817cb92ecd2f04f.svg";